/**
 * MIRE enums + specialised geodata shapes.
 *
 * Mirrors `apps/safecurves/interfaces.ts`: the generic shapes live in
 * `#lib/types.ts`; this file declares the MIRE-specific enums and the
 * narrow `IMireSystemLayers` / `IMireSummaryData` shapes the rest of the
 * MIRE code consumes.
 */

import type { ILayerSource, IFeature as IGenericFeature } from '#lib/types.js';

export enum EMireModule {
	Curves = 'Curves'
}

export enum EProduct {
	MIRE = 'AbleyMIRE'
}

export enum ECurves {
	Curves = 'Curves'
}

/** operational feature — generic IFeature parameterised with EProduct + EMireModule. */
export type IMireFeature = IGenericFeature<EProduct, EMireModule>;

export interface IMireSystemLayers {
	[EMireModule.Curves]: {
		[ECurves.Curves]: ILayerSource | null;
	};
}

export interface IMireSummaryData {
	location_label: string;
	[EMireModule.Curves]: Record<string, string | number>[];
}
